import {
    CONSULTA_REPORTE_GENERAL,
    CONSULTA_REPORTE_DETALLE,
    EXITO_REPORTE_GENERAL,
    EXITO_REPORTE_DETALLE,
    ERROR_NO_CONTROLADO_CONSULTA,
    DESCARGAR_XLS_REPORTE_GLOSAS,
    EXITO_XLS_REPORTE_GLOSAS,
    ERROR_XLS_REPORTE_GLOSAS,
    ERROR_CONTROLADO_CONSULTA,
    LIMPIAR_MENSAJES_ERROR_REPORTE,
    exitoReporteGeneral,
    errorNoControladoConsulta,
    errorControladoConsulta,
    exitoReporteDetalle,
    exitoXlsReporteGlosas,
    errorXlsReporteGlosas
} from "./ReporteGlosasActions";
import { AnyAction } from "redux";
import fileDownload from "js-file-download";
import * as moment from "moment";
import {
    cabeceraReporteDetalleGlosas,
    cabeceraReporteGeneralGlosas,
    LibroDocumentoXLS
} from "../../../general/modelo/PlanillasXLS";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { errorAutorizacion } from "../../../../inicio/modulos/inicioActions";
import { FiltroConsultaReporteGlosas, RespuestaReporteGlosas } from "../modelo/ReporteGlosasModelo";
import { TipoReporteGlosa } from "../modelo/TipoReporteGlosa";
import { RespuestaReporteGeneral, RespuestaReporteDetalle } from "../modelo/ReporteGlosasModelo";
import { crearPlantillaXLS } from "../../../general/componentes/GenerarPlantillaXLS";

export const consultarReporteGeneralEpic = action$ =>
    action$.ofType(CONSULTA_REPORTE_GENERAL)
        .mergeMap((action: any) => {

            const url = `sat/consultar/reporte-glosas/general?${obtenerFiltroConsulta(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    return respuesta.solicitudExito ?
                        exitoReporteGeneral(respuesta.datosGeneral) :
                        errorControladoConsulta(construirMensajeError(respuesta.mensajeRespuesta));
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorNoControladoConsulta()];
                });
        });

export const descargarXlsReporteGlosasEpic = action$ =>
    action$.ofType(DESCARGAR_XLS_REPORTE_GLOSAS)
        .mergeMap((action: any) => {

            const url = `sat/consultar/reporte-glosas/datos-excel?${obtenerFiltroConsulta(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    if (respuesta.solicitudExito) {
                        const excelBlob: Blob = construirXLS(respuesta, action.filtro);
                        const nombreArchivo = `reporte_glosas_${moment(moment.now()).format("DD_MM_YYYY_HHmmss")}.xlsx`;
                        fileDownload(
                            excelBlob,
                            nombreArchivo,
                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        );
                        return exitoXlsReporteGlosas();
                    }
                    return errorXlsReporteGlosas(construirMensajeError(respuesta.mensajeRespuesta));
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorNoControladoConsulta()];
                });
        });

export const consultaReporteDetalleEpic = action$ =>
    action$.ofType(CONSULTA_REPORTE_DETALLE)
        .mergeMap((action: any) => {

            const url = `sat/consultar/reporte-glosas/detalle?${obtenerFiltroConsulta(action.filtro)}`;

            return authenticatedAjax
                .get(url)
                .map(response => {
                    const respuesta = JSON.parse(response.response);
                    return respuesta.solicitudExito ?
                        exitoReporteDetalle(respuesta.datosDetalle) :
                        errorControladoConsulta(construirMensajeError(respuesta.mensajeRespuesta));
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorNoControladoConsulta()];
                });
        });

export const reporteGlosasRespuestaReducer = (state = {
    estado: REQUEST.NONE,
    estadoDescargaXLS: REQUEST.NONE,
    reporteServicios: [],
    reporteDetalle: [],
    mensajeError: undefined
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTA_REPORTE_GENERAL:
            return {
                ...state,
                estado: REQUEST.PENDING,
                reporteServicios: [],
                reporteDetalle: [],
                mensajeError: undefined
            };
        case CONSULTA_REPORTE_DETALLE:
            return {
                ...state,
                estado: REQUEST.PENDING,
                reporteDetalle: [],
                mensajeError: undefined
            };
        case EXITO_REPORTE_GENERAL:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                reporteServicios: action.datosRespuesta
            };
        case EXITO_REPORTE_DETALLE:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                reporteDetalle: action.datosRespuesta
            };
        case ERROR_CONTROLADO_CONSULTA:
            return {
                ...state,
                estado: REQUEST.ERROR,
                mensajeError: action.mensajeError
            };
        case ERROR_NO_CONTROLADO_CONSULTA:
            return {
                ...state,
                estado: REQUEST.ERROR
            };
        case DESCARGAR_XLS_REPORTE_GLOSAS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.PENDING,
            };
        case EXITO_XLS_REPORTE_GLOSAS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.SUCCESS
            };
        case ERROR_XLS_REPORTE_GLOSAS:
            return {
                ...state,
                estadoDescargaXLS: REQUEST.ERROR,
                mensajeError: action.mensajeError
            };
        case LIMPIAR_MENSAJES_ERROR_REPORTE:
            return {
                ...state,
                estado: REQUEST.NONE,
                estadoDescargaXLS: REQUEST.NONE,
                reporteServicios: [],
                reporteDetalle: [],
                mensajeError: undefined
            };
        default:
            return state;
    }
};

const obtenerFiltroConsulta = (filtro: FiltroConsultaReporteGlosas) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.tipoReporte) params.set('tipoReporte', filtro.tipoReporte.toString());
        if (filtro.fechaInicial) params.set('fechaInicio', filtro.fechaInicial);
        if (filtro.fechaFinal) params.set('fechaFin', filtro.fechaFinal);
        if (filtro.codigoServicio) params.set('codigoServicio', filtro.codigoServicio.toString());
        if (filtro.listaServicios)
            filtro.listaServicios.forEach(codigo => params.append('listaCodigos', codigo.toString()));
    }

    return params.toString();
};

const construirXLS = (respuesta: RespuestaReporteGlosas, filtro: FiltroConsultaReporteGlosas) => {
    if (filtro.tipoReporte) {
        if (filtro.tipoReporte === TipoReporteGlosa.REPORTE_EXCEL_GENERAL)
            return construirXLSGeneral(respuesta.datosGeneral);
        if (filtro.tipoReporte === TipoReporteGlosa.REPORTE_EXCEL_DETALLE)
            return construirXLSDetalle(respuesta.datosDetalle);
    }

    return new Blob();
};

const construirXLSGeneral = (datosGeneral: Array<RespuestaReporteGeneral>) => {
    /*Libros a generar en el XLS*/
    const libroDatosGenerales = 'Datos Generales Servicios';

    const librosXLS = [];
    librosXLS.push(libroDatosGenerales);

    const reporteGeneral = [];

    datosGeneral.forEach(dato => {
        reporteGeneral.push([
            { value: dato.nombre },
            { value: dato.OK },
            { value: dato.Glosa },
            { value: dato.Error }
        ]);
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libroDatosGenerales,
        cabecera: cabeceraReporteGeneralGlosas(),
        datos: reporteGeneral,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};

const construirXLSDetalle = (datosDetalle: Array<RespuestaReporteDetalle>) => {
    /*Libros a generar en el XLS*/
    const libroDatosDetalle = 'Datos Detalle Glosas';

    const librosXLS = [];
    librosXLS.push(libroDatosDetalle);

    const reporteDetalle = [];


    datosDetalle.forEach(dato => {
        reporteDetalle.push([
            { value: dato.Servicio },
            { value: dato.Glosa },
            { value: dato.Cantidad },
            { value: dato.TextoGlosa ? dato.TextoGlosa : `No se encontro la Glosa ${dato.Glosa} para el Servicio ${dato.Servicio}.` }
        ]);
    });

    /*Datos para generar el XLS*/
    const datosLibrosXLS: LibroDocumentoXLS[] = [{
        nombreLibro: libroDatosDetalle,
        cabecera: cabeceraReporteDetalleGlosas(),
        datos: reporteDetalle,
    }];

    return crearPlantillaXLS(librosXLS, datosLibrosXLS);
};

const construirMensajeError = (mensajeRespuesta: string) => {
    return mensajeRespuesta ? mensajeRespuesta : "Error no controlado en la aplicación";
};




// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_glosas/modulos/ReporteGlosasReducers.ts